"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    text-align: center;\n    background-color: #fff;\n    font-size: 14px;\n    border-radius: 3px;\n    border: 1px solid ", ";\n    color: ", ";\n    position: relative;\n    padding: 8px;\n    p {\n      line-height: 1.5;\n      margin: 0;\n    }\n    .price-label {\n      font-weight: bold;\n      color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.Label = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme.palette.border.contrast, theme.palette.text.secondary, theme.palette.primary["default"]);
});
exports["default"] = {};